module.exports = __webpack_public_path__ + "static/img/goods-666.a2db19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/goods-666.png
// module id = GH1M
// module chunks = 2